var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIconeRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.071,
    height: 26.071,
    viewBox: "0 0 26.071 26.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone-alt",
    "data-name": "Icon awesome-phone-alt",
    d: "M25.328,18.423l-5.7-2.444a1.222,1.222,0,0,0-1.426.351l-2.526,3.086A18.874,18.874,0,0,1,6.65,10.394L9.736,7.868a1.219,1.219,0,0,0,.351-1.426L7.643.739a1.23,1.23,0,0,0-1.4-.708L.947,1.253A1.222,1.222,0,0,0,0,2.444,23.625,23.625,0,0,0,23.627,26.072a1.222,1.222,0,0,0,1.192-.947l1.222-5.3a1.237,1.237,0,0,0-.713-1.405Z",
    transform: "translate(0 0)",
    fill: "#ec6461"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconeRight);
export default __webpack_public_path__ + "static/media/phoneIconeRight.ff9541e13e57da8666e2836942fe1685.svg";
export { ForwardRef as ReactComponent };